import { Button } from '@forest/shared/react'
import { useStore } from '@nanostores/react'
import { Dialog } from 'radix-ui'
import { m } from '~/paraglide/messages'
import { $reminderDialog, reminderDialog } from '~/store/reminder-dialog'

export function ReminderDialog() {
  const state = useStore($reminderDialog)

  return (
    <Dialog.Root
      open={state.isOpen}
      onOpenChange={(nextIsOpen) => !nextIsOpen && reminderDialog.close()}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[55] bg-black/10 backdrop-blur-[12.5px]" />
        <Dialog.Content
          asChild
          onPointerDownOutside={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
        >
          <div
            className="gradient-outline fixed left-1/2 top-1/2 z-[60] w-[calc(100vw-48px)] max-w-[345px] -translate-x-1/2 -translate-y-1/2 rounded-[32px] backdrop-blur-[50px] [--ow:2px]"
            style={{
              willChange: 'backdrop-filter',
              background: '#FFFFFF8F',
            }}
          >
            <div className="p-6 text-center">
              <Dialog.Title className="text-lg font-semibold text-[#333]">
                {m.dialog_trial_end_notification_title()}
              </Dialog.Title>

              <Dialog.Description className="mt-3 text-[#666]">
                {m.dialog_trial_end_notification_content({
                  date: state.trialEndDate,
                })}
              </Dialog.Description>

              <div className="mt-4 flex flex-col items-center gap-3">
                <Button onClick={reminderDialog.onRemind}>
                  {m.btn_remind_me()}
                </Button>

                <Button
                  variant="ghost"
                  size="sm"
                  onClick={reminderDialog.onDismiss}
                >
                  {m.btn_no_need_reminder()}
                </Button>
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
